import { isDev, createLogger } from "../utilities/debug.js";
import { ComponentRegistrationError, BatchRegistrationError } from "./errors.js";
const TAG_NAME_RE = /^[a-z][a-z0-9]*(-[a-z0-9]+)+$/;
function registerComponent(tagName, element, options) {
  const registry = options?.registry ?? window.customElements;
  const eager = options?.eager ?? true;
  if (!element || typeof element !== "function") {
    throw new ComponentRegistrationError(
      tagName,
      "missing-constructor",
      "Constructor is required and must be a function."
    );
  }
  if (!TAG_NAME_RE.test(tagName)) {
    throw new ComponentRegistrationError(
      tagName,
      "invalid-name",
      `"${tagName}" is not a valid custom element name. Must match ${TAG_NAME_RE}.`
    );
  }
  const existing = registry.get(tagName);
  if (existing) {
    if (existing === element) {
      return false;
    }
    throw new ComponentRegistrationError(
      tagName,
      "conflict",
      `Already registered with a different constructor.`,
      existing
    );
  }
  if (!eager) {
    const hasElement = document.getElementsByTagName(tagName).length > 0;
    if (!hasElement) {
      if (isDev()) {
        const logger = createLogger(tagName);
        logger.debug("Lazy registration skipped — no DOM elements found.");
      }
      return false;
    }
  }
  registry.define(tagName, element);
  return true;
}
function isComponentRegistered(tagName, registry) {
  return (registry ?? window.customElements).get(tagName) !== void 0;
}
function whenComponentDefined(tagName, registry) {
  return (registry ?? window.customElements).whenDefined(tagName);
}
function getComponentConstructor(tagName, registry) {
  return (registry ?? window.customElements).get(tagName);
}
function registerComponents(components, options) {
  const errors = [];
  const succeeded = [];
  for (const { tagName, element } of components) {
    try {
      const result = registerComponent(tagName, element, options);
      if (result) {
        succeeded.push(tagName);
      }
    } catch (error) {
      if (error instanceof ComponentRegistrationError) {
        errors.push(error);
      } else {
        throw error;
      }
    }
  }
  if (errors.length > 0) {
    throw new BatchRegistrationError(errors, succeeded);
  }
}
export {
  getComponentConstructor,
  isComponentRegistered,
  registerComponent,
  registerComponents,
  whenComponentDefined
};
//# sourceMappingURL=registration.js.map
